import classNames from 'classnames';
import * as React from 'react';
import StickyContainer from '../Sticky/StickyContainer.js';
import styles from './Table.module.scss.js';

var Table = function (props) {
    var _a;
    var classNameTable = classNames(styles.table, (_a = {},
        _a[styles.isErrored] = props.isErrored,
        _a[styles.isFetching] = props.isFetching,
        _a), props.className);
    return props.stickyContainerId ? (React.createElement(StickyContainer, { id: props.stickyContainerId },
        React.createElement("div", { className: classNameTable }, props.children))) : (React.createElement("div", { className: classNameTable }, props.children));
};

export { Table as default };
//# sourceMappingURL=Table.js.map
